import React, { useState, useEffect } from 'react';
import { ListItem } from '../ListItem/ListItem';
export const Dropdown = (props) => {
  const { styles, handleChange, data, name, list, action, value, selection, type, submitted, disabled, notRequired, className } = props;

  // const [type, styles, handleChange, data, placeholder, submitted ] = useState(...props);

  //   function myFunction() {
  //     var input, filter, ul, li, a, i, txtValue;
  //     input = document.getElementById("myInput");
  //     filter = input.value.toUpperCase();
  //     ul = document.getElementById("myUL");
  //     li = ul.getElementsByTagName("li");
  //     for (i = 0; i < li.length; i++) {
  //         a = li[i].getElementsByTagName("a")[0];
  //         txtValue = a.textContent || a.innerText;
  //         if (txtValue.toUpperCase().indexOf(filter) > -1) {
  //             li[i].style.display = "";
  //         } else {
  //             li[i].style.display = "none";
  //         }
  //     }
  // }

  const searchText = (e) => {
    e.preventDefault();
    var input, filter, ul, a, i, txtValue;
    input = document.getElementById(`mySearch${e.target.name}`);
    filter = input.value.toUpperCase();
    ul = document.getElementById(e.target.name);
    a = ul.getElementsByTagName('a');
    for (i = 0; i < a.length; i++) {
      txtValue = a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = '';
      } else {
        a[i].style.display = 'none';
      }
    }
  };

  return (
    <div className={styles.LoginPage__formBox}>
      <div className={`${styles.dropdown} ${className}`}>
        <button type={type} onClick={() => selection(!value)} name={name} onChange={(e) => handleChange(e)} disabled={disabled}>
          {data}
        </button>
        <div id={name} className={styles.dropdown__droppop + ` ` + `${value ? styles.show : styles.hide} `}>
          {name != 'ID Type' ? <input autoComplete="off" type="text" id={'mySearch' + name} name={name} onKeyUp={(e) => searchText(e)} /> : ''}
          {list ? <ListItem list={list} action={action} /> : <h4>No Records Found</h4>}
        </div>
      </div>
      {submitted && data == name && !notRequired && <div className={styles.LoginPage__error}>{name} is required</div>}
    </div>
  );
};
